const reviews = [
  {
    Para: "Hello Mediatech Thank u so much for ur efforts on our project Veterinary medicine management system.U really spent a lot of time nd also scheduled some meets to make us easily understand the concept. Ur dedication Is really appreciable. At the end of the day our project has been successfully completed the execution nd we also scored gud marks .thank u once again",
    Name: "Abhinaya",
    Work: "Student",
    image:"https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    Para: "Hello Mediatech Thank u so much for ur efforts on our project Veterinary medicine management system.U really spent a lot of time nd also scheduled some meets to make us easily understand the concept. Ur dedication Is really appreciable. At the end of the day our project has been successfully completed the execution nd we also scored gud marks .thank u once again",
    Name: "Abhinaya",
    Work: "Student",
    image:"https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    Para: "Hello Mediatech Thank u so much for ur efforts on our project Veterinary medicine management system.U really spent a lot of time nd also scheduled some meets to make us easily understand the concept. Ur dedication Is really appreciable. At the end of the day our project has been successfully completed the execution nd we also scored gud marks .thank u once again",
    Name: "Abhinaya",
    Work: "Student",
    image:"https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  
];

export default reviews;
